import React, {useCallback, useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Button, IconButton, makeStyles, Tooltip} from '@material-ui/core';
import {AddRemoveIconButtons, ExpansionPanel, Loading} from '@cabinet-packages/components';
import {useDispatch, useSelector} from "react-redux";
import {getCatalog, setSelectedComplex} from "@cabinet-packages/redux";
import Typography from "@material-ui/core/Typography";
import {AddShoppingCart} from "@material-ui/icons";
import {isIncludedInComplexResearch} from "@cabinet-packages/helpers";
import PiggyBank from "medis/src/assets/images/catalogTableImages/piggy_bank.svg";
import {Helmet} from "react-helmet";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {getAssayInfo} from "@cabinet-packages/api";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    padding: '10px',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '1fr',
    gridGap: '10px',
    fontFamily: 'Geometria, sans-serif'
  },
  containerInfoAssay: {
    background: '#f6f7fc',
    display: 'flex',
    flexDirection: 'row',
    padding: '0px 10px',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
    }
  },
  priceTextWrapper: {
    color: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    userSelect: 'none',
    justifyContent: 'space-between',
    verticalAlign: 'center',
    width: '40%',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      width: '100%',
    }
  },
  priceText: {
    color: '#144c7b',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '@media (max-width: 900px)': {
      width: '100%',
    },
  },
  nameOfAssay: {
    alignItems: 'center',
    paddingRight: '8px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '60%',
    color: 'rgb(105, 110, 119)',

    '@media (max-width: 900px)': {
      width: '100%',
    }
  },
  details: {
    display : "block",
  },
  scrollWrapper: {
    position: 'relative',
    width: '100%',
  },
  scrollContainer: {
    position: 'absolute',
    width: '100%',
    maxHeight: '100%',
    overflow: 'auto',
    padding: '8px',
    listStylePosition: 'outside',

    '& .content':{
      color: 'rgb(105, 110, 119)',
      paddingLeft: '16px'
    },
  },
  buttonForReturnWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  addRemoveButton: {
    margin: '8px',
    width: '80%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '@media (max-width: 900px)': {
      width: '95%',
      margin: '0px',
      padding: '8px',
    }
  },
  addRemoveButtonText: {
    color: 'white',
    fontSize: '20px',
    fontWeight: '300',
    lineHeight: '56px',
    padding: '0 8px'
  },
  piggyButton: {
    padding: '8px',
  },
  accordionDetails: {
    display: 'block',
  },
  accordionDetailsHeader: {
    padding: '8px 8px 8px 0',
    // color: theme.palette.primary.main,
  },
}));

function AssayInfo({isComponentInShop}) {
  const location = useLocation();
  const classes = useStyles();
  const {catalog, complexResearch, takeId, complexId} = useSelector(state => state.assaysCatalog);
  const { orderingList } = useSelector(state => state.orderAssays);
  const [item, setItem] = useState(null);
  const [assayInfo, setAssayInfo] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const hrefLocation = window.location.href;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const isIncludedInOrderingList = item && orderingList.find(assay => assay.id === item.id && assay.type === item.type);

  const handleAssayInfo = useCallback(async () => {
    if (!assayInfo && item) {
      setLoading(true);
      setError(false);

      try {
        const data = await getAssayInfo(item.id);

        setAssayInfo(p=>({
          ...p,
          ...item,
          ...data
        }))
      } catch (e) {
        console.error(e);
        setError(true);
      }
      setLoading(false);
    }
  }, [assayInfo, item]);

  useEffect(() => {
    handleAssayInfo();
  }, [handleAssayInfo])

  const handleTransitionToComplexResearch = (event, item) => {
    event.stopPropagation();
    event.preventDefault();

    const foundedComplex = complexResearch.filter(com => com.filling.find(fill => !!item.filling.find(itemFill => itemFill.id === fill.id)));

    dispatch(setSelectedComplex({
      assayName: item.name
          ? item.name
          : item.testNames.split(',')[0].split('\\\\').join(''),
      foundedComplex
    }));

    isComponentInShop
        ? history.push('/shop-complex')
        : history.push('/comprehensive-research')
  };

  const handleTransitionToCatalog = (event) => {
    event.stopPropagation();
    event.preventDefault();

    history.push('/catalog-table');
  };

  useEffect(() => {
    if (catalog) {
      const id = location.pathname.split('/');
      const item = catalog.find((item)=> +item.id === +id[id.length-1] && !item.superGroupName);
      if (item) {
        setItem(item);
        // setAssayInfo(item);
      } else {
        setItem(false)
      }
    }
  }, [catalog, dispatch, location]);

  useEffect(() => {
    if (!catalog && takeId && complexId) dispatch(getCatalog());
  }, [catalog, dispatch, takeId, complexId]);

  if (!catalog || item === null) {
    return <Loading/>;
  }

  return (
      item !== false
          ? <div className={classes.root} key={item.id}>
            <div className={classes.containerInfoAssay}>
              <Tooltip title="Натисніть щоб повернутись назад." arrow>
                <IconButton onClick={() =>  history.goBack()} style={{padding: '8px'}} className={classes.arrowBack}>
                  <ArrowBackIcon style={{color: '#144c7b'}} color={'inherit'} fontSize={'inherit'} />
                </IconButton>
              </Tooltip>
              <div className={classes.nameOfAssay}>
                {item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join('')}
              </div>
              <div className={classes.priceTextWrapper}>
                {isIncludedInComplexResearch(item, complexResearch)
                    ? <Tooltip title="Натисніть щоб переглянути комплекси з цим дослідженням." arrow>
                      <IconButton
                          size="small"
                          onClick={(event)=>handleTransitionToComplexResearch(event, item)}
                          className={classes.piggyButton}
                      >
                        {takeId === 14
                            ? <img src={PiggyBank} style={{width: '40px'}} alt="Piggy bank."/>
                            : <AddShoppingCart style={{width: '40px'}}/>}
                      </IconButton>
                    </Tooltip>
                    : ' '
                }
                <div className={classes.priceText}>{Math.ceil(item.price - item.price * item.discount / 100)} грн</div>
                <div className={classes.addRemoveButton}>
                  {+item.idParent !== +takeId && <AddRemoveIconButtons
                      item={item}
                      isIncludedInOrderingList={isIncludedInOrderingList}
                      assayInfo={true}
                      ceil={true}
                  />}
                </div>
              </div>
            </div>
            <div className={classes.scrollWrapper}>
              <div className={classes.scrollContainer}>
                {assayInfo && <ExpansionPanel defaultExpanded={true} classNameDetails={classes.accordionDetails}>
                  {/*{assayInfo && assayInfo.filling && [...(assayInfo.filling || []), ...(assayInfo?.idGrTest || [])].map((fil, i) => {*/}
                  {/*  return (fil.name ?*/}
                  {/*      <TableRow*/}
                  {/*          key={i}*/}
                  {/*          style={{background: isIncludedInOrderingList*/}
                  {/*                ? i%2 === 0 ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.2)'*/}
                  {/*                : takeId === 14*/}
                  {/*                    ? i%2 === 0 ? 'none': 'rgba(0, 0, 0, 0.05)'*/}
                  {/*                    : 'none'}*/}
                  {/*          }*/}
                  {/*      >*/}
                  {/*        <TableCell*/}
                  {/*            className={classes.tableTd}*/}
                  {/*            style={{cursor: 'pointer'}}*/}
                  {/*        >*/}
                  {/*          {fil.name}*/}
                  {/*        </TableCell>*/}
                  {/*        <TableCell className={classes.tableTd}/>*/}
                  {/*        <TableCell className={classes.tableTd}/>*/}
                  {/*      </TableRow>*/}
                  {/*  : <div key={i}></div>)*/}
                  {/*})}*/}
                  {assayInfo.definition && <div>
                    <h3 className={classes.accordionDetailsHeader}>Визначення:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.definition}}/>
                  </div>}
                  {!!item.test.length && <div>
                    <h3 className={classes.accordionDetailsHeader}>Дослідження:</h3>
                    {[...item.test, ...(item?.testNamesArr || [])].reduce((acu, cur) => {
                      if (acu.find((item) => item === cur)) {
                        return acu
                      }

                      return [...acu, cur]
                    }, []).map((test, index) => <p key={index} className="content">{test}</p>)}
                  </div>}
                  {assayInfo.deviation && <div>
                    <h3 className={classes.accordionDetailsHeader}>Відхилення від норм:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.deviation}}/>
                  </div>}
                  {assayInfo.recommendations && <div>
                    <h3 className={classes.accordionDetailsHeader}>Рекомендації:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.recommendations}}/>
                  </div>}
                  {assayInfo.synonyms && <div>
                    <h3 className={classes.accordionDetailsHeader}>Синоніми:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.synonyms}}/>
                  </div>}
                  {assayInfo.when && <div>
                    <h3 className={classes.accordionDetailsHeader}>Коли призначають:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.when}}/>
                  </div>}
                  {assayInfo.ua_rules && <div>
                    <h3 className={classes.accordionDetailsHeader}>Правила підготовки:</h3>
                    <div className="content" dangerouslySetInnerHTML={{__html: assayInfo.ua_rules}}/>
                  </div>}
                  {!!item.material.length && <div>
                    <h3 className={classes.accordionDetailsHeader}>Матеріал:</h3>
                    {item.material.map((material, index) => <p className="content" key={index}>{material}</p>)}
                  </div>}
                </ExpansionPanel>}
              </div>
            </div>
         <div className={classes.buttonForReturnWrapper}>
              <Button
                  onClick={handleTransitionToCatalog}
                  variant="outlined"
                  color="primary"
                  className={classes.buttonForReturn}
              >
                Назад до переліку досліджень
              </Button>
            </div>
            {item && item.testNames && <Helmet>
              <meta name="og:description" content={item.testNames}/>
              <meta property="og:url" content={hrefLocation}/>
              <meta name="og:image" content={'imgUrl'}/>
              {/*<meta property="og:site_name" content={takeId === 14 ? 'Medis' : 'Esculab'}/>*/}
              <meta property="og:type" content="article" />
              <meta property="og:title" content={item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join('')} />
            </Helmet>}
          </div>
          : <div><Tooltip title="Натисніть щоб повернутись назад." arrow>
            <IconButton onClick={() =>  history.goBack()} style={{padding: '8px'}} className={classes.arrowBack}>
              <ArrowBackIcon color={'primary'} fontSize={'inherit'} />
            </IconButton>
          </Tooltip>
            <p>Вибачте, це дослідження не доступне в даний момент.</p>
          </div>
  );
}

export default AssayInfo;
